// Copyright ©️ 2026 eVolve MEP, LLC

import { FLAT_BLACK_FILLER } from '@evolvemep/api-ts';

import freehandSvg from 'assets/icons/icon-src/markup/freehand.svg?raw';
import {
  BaseMarkupTool,
  type MarkupToolContext,
  type PanelConfig,
} from 'components/Autodesk/extensions/MarkupModeExtension/BaseMarkupTool';

const { Autodesk } = window;

export class FreehandTool extends BaseMarkupTool {
  readonly type = 'freehand'; // Matches the existing type used by Autodesk's freehand markup tool, which we build on top of.

  constructor(context: MarkupToolContext) {
    super(context, {
      strokeWidth: 2,
      strokeColor: FLAT_BLACK_FILLER,
      strokeOpacity: 100,
    });
  }

  protected getPanelConfig(): PanelConfig {
    return {
      panelTitle: 'Freehand',
      sections: [
        {
          heading: 'Outline',
          fields: [
            { property: 'stroke-width', label: 'Size' },
            { property: 'stroke-color', colorLabel: 'Color', opacityLabel: 'Opacity' },
          ],
        },
      ],
    };
  }

  protected activateEditMode() {
    const freehandEditMode = new Autodesk.Viewing.Extensions.Markups.Core.EditModeFreehand(this.markupExtension);
    this.markupExtension.changeEditMode(freehandEditMode);
  }

  protected readonly buttonIcon = freehandSvg;
  protected readonly buttonTooltip = 'Freehand';
}
